import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import MailEdit from "../../components/MailEdit";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import InputAdornment from '@mui/material/InputAdornment';
import TextareaAutosize from '@mui/material/TextareaAutosize';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});
export default function CreatePost(){
    const [penelpon,setPenelpon]=useState();
    const [mencari, setMencari] = useState();
    const [noTelpPenelpon, setNoTelpPenelpon]=useState();
    const [tujuan, setTujuan] = useState();
    const nowstate = useSelector(state => state);
    const [tanggalKejadian,setTanggalKejadian] = useState(new Date())
    const [statNotify,setStatNotify] =useState("No")
    const [error,setError] = useState();

    const simpanCall = () => {
        if(penelpon){
    
            // Assuming that fileFoto is your file objects
           
              const tipe="SharedCall";
              let dataCall = 
                {
                penelpon,
                mencari,
                noTelpPenelpon,
                tujuan,
            }
    
              
              // Now, post the data to your endpoint
              axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveCall`,{
                tipe,
                dataCall,
                tanggalKejadian,
                statNotify,
                useData,
                searchThis
              })
              .then((response) => {
                navigate("/")
              })
              .catch((error) => {
                console.log(error.message);
                setError(error.response.data.message);
              });
            
    
    
        }else{
            setError("Ada data kosong")
        }
    }

    const anotherCallForwardPotential = () => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/newPotentialPulsaUser`, {
            useData, user:nowstate.user
        }).then(() => {
        }).catch(error => {
            // handle error
            console.log(error);
        }); 
    }
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);

    async function newInquiry(e){
        history("/new-inquiry",{state:{stuff:"new"}})
    }
    const [editMailOpen,setEditMailOpen] = useState(false)
    const [useData,setUseData] =useState();
    async function editInquiry(post){
        setEditMailOpen(true)
        anotherCallForwardPotential()
        setUseData(post)
    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }


                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }

            console.log(data)
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
    
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            console.log(data.data)

            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)

                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("Perusahaan");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeeditMailOpen = () => {
        setEditMailOpen(false)
    }

    const openSignatureNow = () => {
        setOpenSignature(true)

    }

    return <Grid container>
                <Dialog open={editMailOpen}  maxWidth='xl'>
                <DialogTitle id="alert-dialog-title">
                <Button onClick={closeeditMailOpen} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
               
    <DialogContent>
    <Grid xs={12} container sx={{p:1}}>
    <ThemeProvider theme={darkTheme}>

                <Grid xs={9} container>
                <Paper elevation={3} sx={{ padding: 2, margin: 2 }}>  {/* Add Paper here */}
                    <Grid xs={12} container>
                                       
                                        <Grid container>
                                            <Grid item xs={2.5}>
                                                <BusinessIcon sx={{ width: 100, height: 100 }} />
                                            </Grid>
                                            <Grid item xs={9.5}>
                                                <Grid container>
                                                    <Grid item xs={4}>Nama Perusahaan</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData?.companyInfo?.namaPerusahaan?? ""}</Grid>
                                                </Grid>

                                                <Grid container>
                                                    <Grid item xs={4}>Industri</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData?.companyInfo?.industri?? ""}</Grid>
                                                </Grid>

                                                <Grid container>
                                                    <Grid item xs={4}>Notes</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData?.companyInfo?.notes ?? "Tidak ada"}</Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                 

                            <Grid item xs={12}>
                                <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
                            </Grid>
                            <Grid container>
                                        <Grid xs={4}>Private Office</Grid>
                                        <Grid xs={0.5}>:</Grid>
                                        <Grid xs={7.5} sx={{mt:1.3}}>
                                        <p style={{ fontFamily: 'Open Sans, sans-serif', fontSize: 'small' }}>
                                        {useData && useData.kontrak && useData.kontrak.length > 0 && useData.kontrak.some(kontrak => kontrak.TipeKontrak === 'Private Office')
                                            ? useData.kontrak
                                                .filter(kontrak => kontrak.TipeKontrak === 'Private Office')
                                                .map((kontrak, index) => {
                                                    return (
                                                    <span key={index}>
                                                        {kontrak?.lokasiSingkatan
                                                        ? `${kontrak.selectedRooms}(` 
                                                        : kontrak.selectedRooms
                                                        }
                                                        {kontrak?.lokasiSingkatan && 
                                                        <b>{kontrak.lokasiSingkatan})</b>
                                                        }
                                                    </span>
                                                    );
                                                })
                                            : 'Tidak ada'}
                                        </p>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{mt:5}}>
                                    Call Handling Detail
                                    <TableContainer component={Paper} sx={{ width: '100%',mt:5 }}>
                                        <Table sx={{ minWidth: 650, width: '100%' }} aria-label="simple table">
                                            <TableHead>
                                            <TableRow>
                                                <TableCell>Nama</TableCell>
                                                <TableCell>Posisi</TableCell>
                                                <TableCell>Case</TableCell>
                                                <TableCell>Method</TableCell>
                                                <TableCell>Nomor</TableCell>
                                            </TableRow>
                                            </TableHead>
                                    <TableBody >   
                                    {useData && useData.listHandling && useData.listHandling.length > 0 ? (
                                        useData.listHandling.map((handling, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{handling.Nama}</TableCell>
                                                <TableCell>{handling.Posisi}</TableCell>
                                                <TableCell>{handling.Case}</TableCell>
                                                <TableCell>{handling.Method}</TableCell>
                                                <TableCell>{handling.Nomor}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">tidak ada text</TableCell>
                                        </TableRow>
                                    )}

                                    </TableBody>
                                    </Table>
</TableContainer>
                                    </Grid>
                            <Grid item xs={12}>
                                <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
                            </Grid>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                       
                                        <TableContainer sx={{ maxHeight: 300, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll">
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            Nama Karyawan
                                                        </TableCell>
                                                        <TableCell>
                                                            Posisi
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {useData && useData.klienList && useData.klienList.map((post) => (
                                                <TableBody>
                                                    <TableRow key={`${post.id}`}
                                                            hover
                                                            >
                                                        <TableCell style={{cursor:'pointer'}}>
                                                            <p>{post.Nama}</p>
                                                        </TableCell>
                                                        <TableCell style={{cursor:'pointer'}}>
                                                            <p>
                                                            {
                                                                post.Companies?.find(
                                                                    company => company.CompanyID === useData.kontrak?.CompanyID
                                                                )?.posisi ?? ""
                                                            }
                                                            </p>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>

                                            ))}

                                            </Table>
                                        </TableContainer>
                            </Paper>
                    </Grid>
                    </Paper>
                    </Grid>
                    </ThemeProvider>
                <Grid container xs={3}>
                <Paper elevation={3} sx={{ padding: 2, margin: 2 }}>  {/* Add Paper here */}
                        <Grid>Penelpon:</Grid>
                        <TextField value={penelpon} onChange={(event)=>setPenelpon(event.target.value)}></TextField>
                        <Grid>Mencari:</Grid>
                        <TextField value={mencari} onChange={(event)=>setMencari(event.target.value)}></TextField>
                        <Grid>No. Telp:</Grid>
                        <TextField value={noTelpPenelpon} onChange={(event)=>setNoTelpPenelpon(event.target.value)}></TextField>
                        <Grid>Tujuan:</Grid>
                        <TextareaAutosize value={tujuan} onChange={(event)=>setTujuan(event.target.value)} style={{ minHeight:"200px", width: "100%" }}></TextareaAutosize>
                        </Paper>
                </Grid>
        </Grid>
        </DialogContent>
        <DialogActions>
                    <Grid style={{ marginRight: 'auto' }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}  style={{ marginRight: 'auto' }}>

                    <MobileDatePicker 
                        views={['year', 'month', 'day']}
                        inputFormat="dd/MM/yyyy"
                        value={tanggalKejadian}
                        onChange={(event)=>setTanggalKejadian(event)}
                        renderInput={(params) => 
                            <TextField 
                                {...params} 
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment >
                                            <CalendarMonthIcon />
                                        </InputAdornment>
                                    ),
                                    style: { height: '35px'}
                                }}
                            />
                        }
                    />

                    </LocalizationProvider>
                    </Grid>
                    <Button variant="contained" color="success" onClick={simpanCall}>
                    <Typography>Simpan dan Notifikasi</Typography>
                    </Button>
                    </DialogActions>
    </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button variant="contained" color="error" style={{ marginRight: 'auto' }}>
                        Batal Kontrak
                    </Button>
                    <Button onClick={() => editPI()}>
                        <EditIcon></EditIcon>
                    </Button>
                    <ColorButton variant="contained" onClick={openSignatureNow}>Upload Tanda Tangan</ColorButton>
                    <Button onClick={() => extend()} variant="contained" color="success">
                        Extend
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="Dedicated Call Center" isi="Cari dengan nomor telepon yang dihubungi"></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Grid sx={{ pl:15}}>

                            <Grid xs={12} container>
                                <Box display="flex" justifyContent="flex-end" width="100%">
                                    <Button sx={{mb:2}} onClick={event => navigate("/NewCall")} variant="contained"><Typography>Cari dengan nama PT/Klien</Typography></Button>
                                </Box>
                                <TextField value={query} onChange={event => handleSearch(event)} fullWidth placeholder="Cari Nomor Telepon yang dihubungi"></TextField>
                            </Grid>
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 350, minHeight: 350 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Nomor Telepon
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover onClick={()=> editInquiry(post)}>
                                                    <TableCell onClick={()=> editInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.nomorTeleponSewa?? ""}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };